export default "__VITE_ASSET__DPSKDLcM__"